import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@material-ui/core';
import { useChangeExtraOptionsStyles } from './styles';

const ChangeExtraOptions = ({ ...props }) => {
  const { item, isChecked, handleChangeOption } = props;
  const classes = useChangeExtraOptionsStyles();

  return (
    <React.Fragment>
      <div className={classes.optionsContainer}>
        <div className={classes.radioContainer}>
          <Radio
            className={classes.radio}
            onChange={() => handleChangeOption(item.newForm)}
            checked={isChecked}
            id={`changeRadio${item.newForm.motiveId}`}
          />
        </div>
        <div className={classes.labelContainer}>
          <div>
            <strong>{item.title}</strong>
          </div>
          <div>{item.subtitle}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

ChangeExtraOptions.propTypes = {
  disabled: PropTypes.bool,
  onCheck: PropTypes.func,
  item: PropTypes.object,
  isChecked: PropTypes.bool,
  handleChangeOption: PropTypes.func,
};

export default ChangeExtraOptions;
